import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppComponent } from './components/app/app.component';  
import { LoginComponent } from './components/login/login.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { NotFound404Component } from './components/not-found404/not-found404.component';

import { RegisterComponent } from './components/register/register.component';
import { RegisterConfirmationComponent } from './components/register-confirmation/register-confirmation.component';
import { CanActivateViaAuthGuard } from './guards/activateGuard';
import { CalendarYearV2Component } from './components/calendar-year-v2/calendar-year-v2.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';

const routes: Routes = [
  { path: 'login',  component: LoginComponent },
  { path: 'register',  component: RegisterComponent },
  { path: 'register-confirmation', component: RegisterConfirmationComponent },
  { path: 'reset-password', component: ResetPasswordComponent }, 
  { path: 'copyright',  component: CopyrightComponent },
  // { path: 'calendar',  component: CalendarComponent, canActivate: [CanActivateViaAuthGuard] },
  // { path: 'calendar-year/:year',  component: CalendarYearComponent, canActivate: [CanActivateViaAuthGuard] },
  // { path: 'calendar-date/:date',  component: CalendarYearComponent, canActivate: [CanActivateViaAuthGuard] },
  // { path: 'calendar-date',  component: CalendarYearComponent, canActivate: [CanActivateViaAuthGuard] },
  { path: 'calendar-year/:year',  component: CalendarYearV2Component, canActivate: [CanActivateViaAuthGuard] },
  { path: 'calendar-date/:date',  component: CalendarYearV2Component, canActivate: [CanActivateViaAuthGuard] },
  { path: '404', component: NotFound404Component},
  { path: '',  redirectTo: "calendar-date/today", pathMatch: 'full' },
  { path: '**', redirectTo: "404"},
]


@NgModule({
    imports : [RouterModule.forRoot(routes)],
    exports: [ RouterModule],
    providers: [ CanActivateViaAuthGuard ]
})

export class AppRoutingModule {}
